import { render, staticRenderFns } from "./ExplanationCard.vue?vue&type=template&id=1b31e30e&scoped=true&lang=html&"
import script from "./ExplanationCard.vue?vue&type=script&lang=js&"
export * from "./ExplanationCard.vue?vue&type=script&lang=js&"
import style0 from "./ExplanationCard.vue?vue&type=style&index=0&id=1b31e30e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b31e30e",
  null
  
)

export default component.exports